import classnames from 'classnames';
import Calendar from 'react-calendar';
import { prettyDate } from '@/helpers/date';
import { DATE_REQUEST } from '@/helpers/common';
import i18n from '@/i18n';
import IconPrev from './assets/icon_prev.svg';
import IconPrevDouble from './assets/icon_prev_double.svg';
import IconNext from './assets/icon_next.svg';
import IconNextDouble from './assets/icon_next_double.svg';
import s from './index.module.scss';

export const DateRangeCalendar = ({
  range,
  onRangeChange,
  doubleView = true,
  minDate,
  maxDate,
}) => (
  <Calendar
    value={range}
    locale={i18n.language}
    onChange={dates =>
      onRangeChange([prettyDate(dates[0], DATE_REQUEST), prettyDate(dates[1], DATE_REQUEST)])
    }
    minDate={minDate}
    maxDate={maxDate}
    className={classnames(s.calendar, doubleView && s.calendar_double)}
    selectRange
    showNeighboringMonth={!doubleView}
    showDoubleView={doubleView}
    returnValue="range"
    next2Label={<img src={IconNextDouble} alt="next-double" width={16} height={16} />}
    prev2Label={<img src={IconPrevDouble} alt="prev-double" width={16} height={16} />}
    nextLabel={<img src={IconNext} alt="next" width={16} height={16} />}
    prevLabel={<img src={IconPrev} alt="prev" width={16} height={16} />}
  />
);
